import { panaceaClient } from './client';

interface PanaceaTenantResponse {
  id: number;
  domains: string[];
  primaryDomain: string;
  name: string | null;
  theme: Record<string, unknown> | null;
  config: Record<string, unknown> | null;
  featuredMealsGardenMealIds: number[];
  featuredMealsSkus: string[];
  featuredMealsTitle: string | null;
  featuredMealsSupportMessage: string | null;
  enableGiftNotes: boolean;
  activeLandingPageConfig: Record<string, unknown> | null;
  APIConfig: {
    svixAppId: string | null;
    svixAppIdStg: string | null;
  } | null;
  createdAt: string;
  updatedAt: string;
  retiredAt: string | null;
}

/**
 * GET `/v1/tenant-config/tenant?id={tenantId}`
 *
 * Retrieves full tenant config (theme, config, featured meals, API config, etc.)
 * along with the currently active landing page config in a single call.
 */
export const fetchTenant = async (
  tenantId: number,
): Promise<PanaceaTenantResponse> => {
  const { data } = await panaceaClient.get<PanaceaTenantResponse>(
    `/v1/tenant-config/tenant?id=${tenantId}`,
  );
  return data;
};
